import React, { Component } from 'react';
import { Link } from 'react-router'
import ContentWrapper from '../../components/Layout/ContentWrapper';
import { Grid, Row, Col, Panel, Button, Table } from 'react-bootstrap';
import Spinner from '../../components/Widgets/spinner';
import { Translate, Localize } from 'react-redux-i18n';

class Users extends Component {
    render() {
        return(
            <ContentWrapper>
                <div className="content-heading"><Translate value="dashboard" /></div>
            </ContentWrapper>
        )
    }
}

export default Users;



// WEBPACK FOOTER //
// ./master/jsx/components/Users/users.jsx